import { Grid } from '@mui/material';
import React from 'react';
import { DASHBOARD_COLORS } from '../../../../../constants';
import { AdminChartCard, MetricCardSkeleton } from '../../components';
import type { IDashboardOverviewProps } from '../../interfaces';

/** Pure metrics section: skeletons while loading, charts once ready. */
export const DashboardOverview = ({
  loading,
  timeData,
  orderedJobOpenings,
  mappedUserAssessments,
}: IDashboardOverviewProps) => {
  if (loading && !timeData) {
    return (
      <Grid container spacing={2}>
        {[0, 1, 2, 3].map((key) => (
          <Grid item xs={12} md={6} lg={3} key={key}>
            <MetricCardSkeleton />
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={6}>
        <AdminChartCard
          label="Job Opening"
          data={orderedJobOpenings}
          loading={loading}
          colors={DASHBOARD_COLORS}
          type="bar"
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <AdminChartCard
          label="Assessment Type"
          data={timeData?.assessments}
          loading={loading}
          colors={DASHBOARD_COLORS}
          type="donut"
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <AdminChartCard
          label="User Assessment Session"
          data={mappedUserAssessments || timeData?.userAssessments}
          loading={loading}
          colors={DASHBOARD_COLORS}
          type="bar"
        />
      </Grid>
    </Grid>
  );
};
